import { explorePathSelector } from 'selectors/appSelector';
import { useSelector } from 'react-redux';

export const useExplorePath = () => {
  return useSelector(explorePathSelector);
};
